import { inject, observer } from 'mobx-react'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { LoadingPage } from '../../MDS-web-ui/src'
import { ActiveLink } from '../Link'

const withAuthorization = (condition) => (Component) => {
  @inject('sessionStore')
  @inject('routing')
  @observer
  class WithAuthentication extends React.Component {
    render() {
      const { sessionStore, routing } = this.props
      const hasAuthorization = condition(sessionStore.authUser)
      const loading = sessionStore.loading
      const { location } = routing

      return loading ? (
        <LoadingPage LinkComponent={ActiveLink} />
      ) : hasAuthorization ? (
        <Component />
      ) : (
        <Navigate
          to={{
            pathname: '/login',
            state: { from: location },
          }}
          replace
        />
      )
    }
  }
  return WithAuthentication
}

export default withAuthorization
